/* ═══════════════════════════════════════════════════
   HERA Bathroom — Shopify Theme JS
   ═══════════════════════════════════════════════════ */

(function() {
  'use strict';



  /* ─── NAV SCROLL ─── */
  var header = document.querySelector('.site-header');
  var stickyBar = document.getElementById('sticky-bar');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 80);
      if (stickyBar) {
        stickyBar.classList.toggle('visible', window.scrollY > 600);
      }
    }, { passive: true });
  }

  /* ─── MOBILE DRAWER ─── */
  var hamburger = document.querySelector('.nav-hamburger');
  var drawer = document.querySelector('.mobile-drawer');
  var overlay = document.querySelector('.mobile-overlay');
  var drawerClose = document.querySelector('.drawer-close');

  function openDrawer() {
    if (drawer) drawer.classList.add('open');
    if (overlay) overlay.classList.add('visible');
    if (hamburger) hamburger.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('visible');
    if (hamburger) hamburger.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (hamburger) hamburger.addEventListener('click', function() {
    drawer && drawer.classList.contains('open') ? closeDrawer() : openDrawer();
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);

  /* Drawer expandable dropdowns */
  document.querySelectorAll('.drawer-dropdown-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      btn.parentElement.classList.toggle('open');
    });
  });

  /* ─── REVEAL ON SCROLL ─── */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) entry.target.classList.add('visible');
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function(el) { observer.observe(el); });
  } else {
    reveals.forEach(function(el) { el.classList.add('visible'); });
  }

  /* ─── FAQ TOGGLE ─── */
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      this.closest('.faq-item').classList.toggle('open');
    });
  });

  /* ─── SMOOTH SCROLL ─── */
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        closeDrawer();
      }
    });
  });

  /* ─── PRODUCT GALLERY THUMBS ─── */
  document.querySelectorAll('.product-gallery__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainImg = document.querySelector('.product-gallery__main img');
      if (mainImg) {
        mainImg.src = this.querySelector('img').src.replace(/_(\d+)x(\d*)\./, '_1200x.');
        mainImg.srcset = this.querySelector('img').dataset.srcset || '';
        document.querySelectorAll('.product-gallery__thumb').forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
      }
    });
  });

  /* ─── PRODUCT VARIANT SWITCHER ─── */
  (function() {
    var productWrap = document.querySelector('[data-product-wrap]');
    var dataEl = document.querySelector('[data-product-json]');
    if (!productWrap || !dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || !data.variants) return;

    var optionSelects = productWrap.querySelectorAll('[data-product-option]');
    var hiddenId = productWrap.querySelector('[data-product-variant-id]');
    var priceEl = productWrap.querySelector('[data-product-price]');
    var addBtn = productWrap.querySelector('[data-product-add]');
    if (!optionSelects.length || !hiddenId) return;

    function formatMoney(cents) {
      var fmt = data.moneyFormat || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    }

    function findVariant() {
      var picked = Array.prototype.map.call(optionSelects, function(s) { return s.value; });
      return data.variants.find(function(v) {
        return v.options.length === picked.length &&
               v.options.every(function(o, i) { return o === picked[i]; });
      });
    }

    function update() {
      var v = findVariant();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      hiddenId.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      }
    }

    optionSelects.forEach(function(s) { s.addEventListener('change', update); });
  })();

  /* ─── QUANTITY BUTTONS ─── */
  document.querySelectorAll('.qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('.qty-input');
      if (!input) return;
      var val = parseInt(input.value) || 1;
      if (this.dataset.action === 'minus' && val > 1) val--;
      if (this.dataset.action === 'plus') val++;
      input.value = val;
      input.dispatchEvent(new Event('change'));
    });
  });

})();
